<template>
   <v-list-item class="text-left ">
       <v-list-item-avatar>
           <v-avatar size="40" color="grey lighten-2">
               <v-img v-if="schedule.specialist && schedule.specialist.avatar" :src="schedule.specialist.avatar"/>
               <v-icon
                       size="18"
                       color="secondary"
                       v-else
               >{{schedule.specialist ? 'fas fa-user-md' : 'fas fa-medkit'}}
               </v-icon>
           </v-avatar>

       </v-list-item-avatar>
       <v-list-item-content>
           <v-list-item-title v-text="schedule.specialist ? `${schedule.specialist.first_name} ${schedule.specialist.last_name}` : `${schedule.service_item.service.name}: ${schedule.service_item.description}`"></v-list-item-title>
           <v-list-item-subtitle>
               <template v-if="nextAvailableEvent">
                   <v-icon  size="18" color="accent lighten-1">fas fa-clock</v-icon>
                   <span class="accent--text ml-2">{{nextAvailableEvent}}</span>
                   <span class="hidden-sm-and-down" v-if="!!schedule.service_item"> | {{schedule.service_item.description}}</span>
               </template>
               <template v-else>
                   <span class="grey--text">(Sin horas disponibles)</span>
               </template>
           </v-list-item-subtitle>
       </v-list-item-content>

   </v-list-item>
</template>

<script>
    export default{
        props: ['schedule'],
        methods:{
            availableDate(event){
                return this.$moment(`${event.date} ${event.time}`).format('ddd D MMM')
            },
            availableTime(event){
                return this.$moment(`${event.date} ${event.time}`).format('HH:mm')
            },
        },
        computed: {
            nextAvailableEvent(){

                var vm = this
                if(!vm.schedule || !vm.schedule.next_available_event){
                    return null
                }

                const nextEvent = vm.schedule.next_available_event

                return `${vm.availableDate(nextEvent)} a las ${vm.availableTime(nextEvent)}`

            }

        }
    }

</script>

<style scoped>
    .arrow{
        width: 40px;
        text-align: center;
    }

</style>
